export default {
  light: {
    fill: 'white',
    stroke: '#282c34',
  },
  dark: {
    fill: '#282c34',
    stroke: '#F8F8F8',
  }
}